import { Step } from 'react-joyride';

const getWorkerAppointmentsTourSteps = (isMobile: boolean): Step[] => {
  const allSteps: (Step & { desktopOnly?: boolean; mobileOnly?: boolean })[] = [
    {
      target: '.tour-title',
      content: (
        <div style={{ textAlign: 'justify' }}>
          En esta sección puedes <strong>ver todas tus citas</strong>. Filtra
          por fecha, estado o servicio, y exporta tus resultados fácilmente si
          lo necesitas.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-date-range',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Usa este selector para <strong>elegir un rango de fechas</strong> y
          ver únicamente las citas programadas en ese período.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-export',
      content: (
        <div style={{ textAlign: 'justify' }}>
          ¿Necesitas llevar un registro? Aquí puedes{' '}
          <strong>exportar tus citas</strong> a formato Excel o PDF para
          imprimir o guardar.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-search-input',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Busca por <strong>servicio, cliente, teléfono, email o tipo de
          pago</strong> para encontrar una cita concreta al instante.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-search-legend',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Filtra además por <strong>estado de la cita</strong> (pendiente,
          confirmada, completada, cancelada...). Puedes combinar varios estados
          a la vez.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-columns-btn',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Pulsa este icono para <strong>elegir qué columnas</strong> quieres
          ver en la tabla. Tu selección se guarda para la próxima vez.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
      desktopOnly: true,
    },
    {
      target: '.tour-table',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Aquí se muestran todas tus <strong>citas detalladas</strong> según
          los filtros aplicados. Haz clic en cualquier cabecera de columna
          para ordenar por ese campo.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
      desktopOnly: true,
    },
    {
      target: '.tour-mobile-cards',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Aquí se muestran todas tus <strong>citas detalladas</strong> según
          los filtros aplicados: hora, cliente, servicio, estado y más.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
      mobileOnly: true,
    },
    {
      target: '.tour-pagination',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Si tienes muchas citas en la lista, usa el selector para cambiar
          cuántas ves por página o los botones para{' '}
          <strong>navegar entre páginas</strong>.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
    },
  ];

  return allSteps
    .filter((s) => !(isMobile && s.desktopOnly) && !(!isMobile && s.mobileOnly))
    .map(({ desktopOnly, mobileOnly, ...step }) => step);
};

export default getWorkerAppointmentsTourSteps;